import * as openpgp from 'openpgp';
import config from '../config/env';

const publicKeyArmored = config.publicKey?.replace(/\\n/g, '\n');

export async function encryptData(data) {
  try {
    const publicKey = await openpgp.readKey({ armoredKey: publicKeyArmored });

    return await openpgp.encrypt({
      message: await openpgp.createMessage({ text: JSON.stringify(data) }),
      encryptionKeys: publicKey
    });
  } catch (error) {
    throw new Error('Failed to encrypt data. Please check your encryption configuration.');
  }
}
